<template>
<div>
  <b-row>
    <b-col class="text-right">
      <router-link :to="{ name: 'EXCMConsentCreate' }" class="btn btn-primary">{{$t('buttons.create')}}</router-link>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <b-card>
        <div v-if="isLoading">
          <Loader></Loader>
        </div>
        <div v-else-if="!isLoading && items.length < 1" >
          {{ $t('views.consents.list.noConsents') }}
        </div>
        <table class="table table-sm table-striped table-hover text-center" v-else>
          <thead>
          <tr>
            <th>{{ $t('views.consents.list.state') }}</th>
            <th>{{ $t('views.consents.list.title') }}</th>
            <th>{{ $t('views.consents.list.description') }}</th>
            <th>{{ $t('views.consents.list.showOnAgreement') }}</th>
            <th>{{ $t('views.consents.list.showOnAgreementSign') }}</th>
            <th>{{ $t('views.consents.list.showOnAgreementAccept') }}</th>
            <th>{{ $t('views.consents.list.showOnline') }}</th>
            <th>{{ $t('views.consents.form.consentType') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>
              <i :class="getIcon(item.status).icon" :style="'color: ' + getIcon(item.status).color" v-b-tooltip.hover :title="getIcon(item.status).toolTip"></i>
            </td>
            <td>{{ item.title }}</td>
            <td>{{ item.description }}</td>
            <td>
              <i :class="getIcon(item.showOnAgreement).icon" :style="'color: ' + getIcon(item.showOnAgreement).color" v-b-tooltip.hover :title="getIcon(item.showOnAgreement).toolTip"></i>
            </td>
            <td>
              <i :class="getIcon(item.showOnAgreementSign).icon" :style="'color: ' + getIcon(item.showOnAgreementSign).color" v-b-tooltip.hover :title="getIcon(item.showOnAgreementSign).toolTip"></i>
            </td>
            <td>
              <i :class="getIcon(item.showOnAgreementAccept).icon" :style="'color: ' + getIcon(item.showOnAgreementAccept).color" v-b-tooltip.hover :title="getIcon(item.showOnAgreementAccept).toolTip"></i>
            </td>
            <td>
              <i :class="getIcon(item.showOnline).icon" :style="'color: ' + getIcon(item.showOnline).color" v-b-tooltip.hover :title="getIcon(item.showOnline).toolTip"></i>
            </td>
            <td><span v-if="item['consentType'] === 0">{{ $t('views.consents.form.forAgreement') }}</span><span v-else-if="item['consentType'] === 1">{{ $t('views.consents.form.forSla') }}</span></td>
            <td>
              <div class="btn-group float-right">
                <router-link tag="button" class="btn btn-link fa fa-search fa-lg"
                             v-b-tooltip.hover :title="$t('buttons.goto')"
                             :to="{name: 'EXCMConsentShow', params: { id: item['@id'] }}">
                </router-link>
                <router-link tag="button" class="btn btn-link fa fa-edit fa-lg"
                             v-b-tooltip.hover :title="$t('buttons.edit')"
                             :to="{name: 'EXCMConsentUpdate', params: { id: item['@id'] }}">
                </router-link>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-if="view">
          <pagination
            :view="view"
            @getPage="getPage($event)"
          ></pagination>
        </div>
      </b-card>
    </b-col>
  </b-row>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'excmconsent/del/deleted',
    error: 'excmconsent/list/error',
    items: 'excmconsent/list/items',
    isLoading: 'excmconsent/list/isLoading',
    view: 'excmconsent/list/view'
  }),

  data () {
    return {
      searchParams: {
        '_page': 1,
        'state': 1
      }
    }
  },

  created () {
    // let url = '/api/e_x_c_m_consents?_page=1&state=1'
    let url = addParamsToQuery('e_x_c_m_consents', this.searchParams)
    this.getPage(url)
  },

  methods: {
    ...mapActions({
      getPage: 'excmconsent/list/default'
    }),
    getIcon (num) {
      if (num === 1) {
        return { icon: 'fa fa-check-circle fa-lg', color: '#28a745', toolTip: this.$t('buttons.yes') }
      } else {
        return { icon: 'fa fa-times-circle fa-lg', color: '#dc3545', toolTip: this.$t('buttons.no') }
      }
    }
  }
}
</script>
